// extracted by mini-css-extract-plugin
export default {"popoverBackdrop":"Popover_popoverBackdrop__aPBAI","content":"Popover_content__tpPbq"};